interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  borderRadius?: string;
  className?: string;
}

/**
 * A single shape-matched loading placeholder. Compose multiple instances
 * to mimic the layout of the content about to load (e.g. SkeletonTable
 * stacks several row-height instances). Pure CSS animation, defined once
 * in global.css's .skeleton class — no JS animation library needed.
 */
export function Skeleton({ width = "100%", height = "1rem", borderRadius, className = "" }: SkeletonProps) {
  return (
    <span
      className={`skeleton ${className}`.trim()}
      style={{
        display: "block",
        width,
        height,
        borderRadius,
      }}
      aria-hidden="true"
    />
  );
}
